import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CourseTrack, QuizSubmission, QuizAnswerResponse } from '../shared/models';

@Injectable({ providedIn: 'root' })
export class AcademyQuizService {
  constructor(private http: HttpClient) {}

  getTrackWithQuiz(trackId: number): Observable<CourseTrack> {
    return this.http.get<CourseTrack>(`/api/v1/course_tracks/${trackId}`, {
      params: { include_quiz: 'true' },
    });
  }

  submitQuiz(trackId: number, userChoices: QuizSubmission): Observable<QuizAnswerResponse[]> {
    return this.http.post<QuizAnswerResponse[]>(
      `/api/v1/course_tracks/${trackId}/submit_answers`,
      { user_choices: userChoices },
    );
  }
}
